define('gigaset_csp/components/handsetbase/registration',[
	"jquery",
	"cartware/components/_base",
	"cartware/components/PubSubHub",
	"cartware/jquery/bem",
	"shoptheme/components/tracking",
	"magnific-popup"
], function(
	$,
	Component,
	PubSubHub,
	BEM
) {
	return Component.create({
		block: null,
		productData: null,

		currentHandset: null,
		currentBasestation: null,

		// 1x1 transparent gif
		fallbackImage: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",

		$init: function() {
			this.block = BEM.block("csp-registration");

			this.handsetSelect = this.block.getElements("handsets");
			this.handsetImage = this.block.getElements("handsetImage");
			this.handsetImageWrapper = this.block.getElements("image-wrapper-handset");
			this.handsetText = this.block.getElements("handsetText");
			this.handsetTextWrapper = this.block.getElements("text-wrapper-handset");
			this.handsetProductImage = this.block.getElements("productImageHandset");


			this.basestationSelect = this.block.getElements("basestations");
			this.basestationImage = this.block.getElements("basestationImage");
			this.basestationImageWrapper = this.block.getElements("image-wrapper-basesation");
			this.basestationText = this.block.getElements("basestationText");
			this.basestationTextWrapper = this.block.getElements("text-wrapper-basesation");


			this.basestationProductImage = this.block.getElements("productImageBasestation");

			this.popupLink = this.block.getElements("zoomLink");

			var productDataId = "productData_" + this.block.find("[data-products-id]").data("products-id");

			this.productData = productDataId in window ? window[productDataId] : {};
			this.bindEvents();

			this.parseUrl();
			this.manualPopup();
			this.setHandsetProductImage();
			this.setBasestationProductImage();

			$(window).on('hashchange', $.proxy(this.parseUrl, this));
		},

		manualPopup: function() {

			$(document).on("click", '.cc_container p a', function (e) {

				var link = $(e.currentTarget);
				if (link.hasClass('cc_btn')) {
					return;
				}
				e.preventDefault();


				link.prop('href', self._updateUrlParameter(link.prop('href'), 'isAjax', 1));

				link.magnificPopup({
					type: 'ajax',
					callbacks: {
						parseAjax: function (mfpResponse) {
							var html = mfpResponse.data.replace(/<script[^>]*>([\s\S]*?)<\/script>/gi, '');

							mfpResponse.data = self._renderPopup({
								body: html
							});
						}
					}
				}).magnificPopup('open');
			});

			this.popupLink.on('click', function(e) {
				e.preventDefault();

				var link = $(this).find('img').attr('src');

				$(this).magnificPopup({
					items: {
						src: link
					},
					type: 'image'
				}).magnificPopup('open');

			});


		},

		parseUrl: function() {
			var urlMatches = /#(.+)/.exec(document.location);

			if (urlMatches) {
				$.each(urlMatches[1].split("&"), $.proxy(function(i, fragment) {
					var parts = /(.+?)=(\d+)/.exec(fragment);

					if (!parts) return;

					if (parts[1] === "basestation") {
						this.setBasestationInternal(parts[2]);
					} else if (parts[1] === "handset") {
						this.setHandsetInternal(parts[2]);
					}
				}, this));
			}
		},

		bindEvents: function() {
			this.handsetSelect.on("change", $.proxy(function(e, preventLoop) {
				preventLoop || this.setHandset(this.handsetSelect.val());
			}, this));

			this.basestationSelect.on("change", $.proxy(function(e, preventLoop) {
				preventLoop|| this.setBasestation(this.basestationSelect.val());
			}, this));
		},

		setHandset: function(value) {
			this.setHandsetProductImage();

			this.setUrlHash("handset", value);
			return this;
		},

		setHandsetProductImage: function() {
			if (this.handsetSelect.val() && this.productData[this.handsetSelect.val()].image) {
				this.handsetProductImage.attr("src", this.productData[this.handsetSelect.val()].image);
			} else {
				this.handsetProductImage.attr("src", this.handsetProductImage.attr('data-default-src'));
			}
		},

		setBasestation: function(value) {
			this.setBasestationProductImage();

			this.setUrlHash("basestation", value);
			return this;
		},

		setBasestationProductImage: function() {
			if (this.basestationSelect.val() && this.productData[this.basestationSelect.val()].image) {
				this.basestationProductImage.attr("src", this.productData[this.basestationSelect.val()].image);
			} else {
				this.basestationProductImage.attr("src", this.basestationProductImage.attr('data-default-src'));
			}
		},

		setHandsetInternal: function(value) {
			this.handsetSelect.val(value).trigger("change", true);
			this.currentHandset = value in this.productData ? this.productData[value] : null;
			this.currentHandset.uid = value;
			this.onChange();
			return this;
		},

		setBasestationInternal: function(value) {
			this.basestationSelect.val(value).trigger("change", true);
			this.currentBasestation = value in this.productData ? this.productData[value] : null;
			this.currentBasestation.uid = value;
			this.onChange();
			return this;
		},

		onChange: function() {
			if (this.currentHandset) {
				if (this.currentHandset.mobile && this.currentHandset.mobile.type == 'file') {
					this.handsetTextWrapper.removeClass('active');
					this.handsetImageWrapper.addClass('active');
					this.handsetImage.attr("src", this.currentHandset.mobile.content ? this.currentHandset.mobile.content : this.fallbackImage);
				} else {
					this.handsetImageWrapper.removeClass('active');
					this.handsetTextWrapper.addClass('active');
					this.handsetText.html(this.currentHandset.mobile ? this.currentHandset.mobile.content : '');
				}
			}

			if (this.currentBasestation) {
				if (this.currentBasestation.base && this.currentBasestation.base.type == 'file') {
					this.basestationTextWrapper.removeClass('active');
					this.basestationImageWrapper.addClass('active');
					this.basestationImage.attr("src", this.currentBasestation.base.content ? this.currentBasestation.base.content : this.fallbackImage);
				} else {
					this.basestationImageWrapper.removeClass('active');
					this.basestationTextWrapper.addClass('active');
					this.basestationText.html(this.currentBasestation.base ? this.currentBasestation.base.content : '');
				}
			}

			if (this.currentHandset && this.currentBasestation) {
				this.registerProductCombination();
			}

			this.manualPopup();
		},

		setUrlHash: function(key, value) {
			var hash = window.location.hash,
				originalHash = hash,
				regex = new RegExp(key + "=\\d+");

			if (regex.match(hash)) {
				hash = hash.replace(regex, key + "=" + value);
			} else {
				hash += hash.substr(0, 1) === "#" ? "&" : "#";
				hash += key + "=" + value;
			}

			hash = hash.replace(/&$/, ""); // strip trailing "&"

			if (hash !== originalHash) {
				window.location.hash = hash;
			}
		},

		registerProductCombination: function () {
			PubSubHub.emit("csp.handsetbase.registration.view", {
				handset: this.currentHandset,
				basestation: this.currentBasestation
			});
		}
	});
});
